import {
  createStore
} from 'vuex'

export default createStore({
  state: {
    token: localStorage.getItem("csm-token") || "", //登录凭证
    socketInfo: JSON.parse(localStorage.getItem("csm-socket")) || null, //socket 用户信息
    socketMsg: null, // socket 实时数据
    socketOnline: null, // socket 实时数据
    parkData: null, //接入事件右侧数据
    menuShow: false,//是否显示菜单
    isAnswer: false,//是否直接接听
    notifyInfo: null,//通知信息
    isAnswering: null,//是否接听中


  },
  mutations: {
    SET_TOKEN (state, value) {
      state.token = value;
      value ? localStorage.setItem("csm-token", value) : localStorage.removeItem("csm-token");
    },
    //登录时设置的socket 链接账密
    SET_SOCKET (state, value) {
      state.socketInfo = value;
      value ? localStorage.setItem("csm-socket", JSON.stringify(value)) : localStorage.removeItem(
        "csm-socket");
    },
    //socket 设置的消息
    SET_SOCKET_MSG (state, value) {
      state.socketMsg = value;
    },
    //socket 设置在线的摄像头
    SET_SOCKET_ON_LIINE (state, value) {
      state.socketOnline = value;
    },
    //设置接入事件数据
    SET_PARK (state, value) {
      state.parkData = value;
    },
    //设置菜单是否展示
    SET_MENU (state, value) {
      state.menuShow = value;
    },
    //设置是否免接听
    SET_ANSWER (state, value) {
      state.isAnswer = value;
    },
    //通知信息
    SET_NOTIFY (state, value) {
      state.notifyInfo = value;
    },
    //是否接听中
    SET_ANSWERING (state, value) {
      state.isAnswering = value;
    },
  },
  actions: {},
  modules: {}
})
